﻿/* 
Object:         Occupancy Region Map
Description:    Logic and events for the module Occupancy Region Map
Used in:        Occupancy Region Map
*/

/*---[ ESLint ]---*/
/*
    global google, occupancyRegion
*/
window.occupancyRegionMap = function () {

    // Local array of markers
    var markers = [];

    // Local array of popup windows 
    var infoWindows = [];

    // counter number of popups
    var counterPopupOpen = 0;

    /**
    * SetLoadingContent
    * @param {any} infowindow
    */
    function SetLoadingContent(infowindow) {
        infowindow.setContent("<div style=\"width: 15px; height: 15px;\" class=\"k-i-loading\"> </div>");
    }

    /**
    * get marker icons
    * @param {any} getMarkerIcon
    */
    function getMarkerIcon(occupancy)
    {
        if (occupancy < 100) {
            var pinImage = new google.maps.MarkerImage(appsettings.getUrl("images/Maps/icon_nooccupancy.png"),
                new google.maps.Size(43, 43),   // size
                new google.maps.Point(0, 0),    // origin
                new google.maps.Point(21, 21),  // anchor
                new google.maps.Size(43, 43)    // scaled size
            );

            return pinImage;

        } else if (occupancy > 100) {

            var image = {
                url: appsettings.getUrl("images/Maps/icon_occupancy.png"),
                size: new google.maps.Size(43, 43),         // size
                scaledSize: new google.maps.Size(43, 43),   // origin
                origin: new google.maps.Point(0, 0),        // the origin for this image is (0, 0).
                anchor: new google.maps.Point(21, 21)       // scaled size
            };

            return image;

        } else {
            var yellow_image = {
                url: appsettings.getUrl("images/Maps/icon_min_occupancy.png"),
                size: new google.maps.Size(43, 43),         // size
                scaledSize: new google.maps.Size(43, 43),   // origin
                origin: new google.maps.Point(0, 0),        // the origin for this image is (0, 0).
                anchor: new google.maps.Point(21, 21)       // scaled size
            };

            return yellow_image;
        }
    }

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    return {

        /**
         * initialize overview with all the events bound to the buttons.
         * @param {any} userId
         */
        initialize: function () {
            occupancyRegionHours = {};

            $("#container-occupancymap").load(appsettings.getUrl("occupancyRegionMap/OccupancyMap?timeSelection=0"));
        },

        /**
         * delete a item (param is event data)
         * @param {any} e
         */
        deleteItem: function (e) {
            
        },

        /**
         * onChangeTimeInterval
         * @param {any} e
         */
        onChangeTimeInterval: function (e) {
            var timeSelection = $('#TimeSelectionId').val();
            $("#container-occupancymap").load(appsettings.getUrl("occupancyRegionMap/OccupancyMap?timeSelection=" + timeSelection));
        },

        /**
         * onChangeTimeInterval
         * @param {any} element
         * @param {any} timeSelection
         * @param {any} nodeId
         */
        refreshOccupancy: function(element, timeSelection, nodeId) {
            $('#buttonDaysOccupancy_' + nodeId + ' button').removeClass('bttnActive');
            $(element).addClass('bttnActive');
            $("#contentOccupancy" + nodeId).html("<div style=\"width: 15px; height: 15px;\" class=\"k-i-loading\"> </div>");

            var currentDate = new Date(new Date().toDateString());
            var selectedDate = addDays(currentDate, timeSelection);
            occupancyRegion.PresentationDate = selectedDate;

            // Post Data
            $.ajax({
                type: "POST",
                url: appsettings.getUrl("occupancyRegion/OccupancyRegionNodesWNodeID"),
                data: {
                    nodeId: parseInt(nodeId),
                    selectedDate: selectedDate.toDateString()
                },
                success: function (data) {
                    $('#contentOccupancy' + nodeId).html(data);
                    occupancyRegion.loadNotOccupiedGroups();
                }
            });
        },

        /**
         * initialize_map
         * @param {int} nodeId
         * @param {enum} timeSelection
         */
        initialize_map: function (nodeId, timeSelection) {

            bounds = new google.maps.LatLngBounds();

            map = new google.maps.Map(document.getElementById('mapview'), {
                center: { lat: 51.944710, lng: 5.336113 },
                zoom: 8
            });

            $.ajax({
                type: "GET",
                url: appsettings.getUrl("occupancyRegionMap/GetMarkers"),
                data: {
                    nodeId: nodeId,
                    timeSelection: timeSelection
                },
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function (result) {
                    for (var i = 0; i < result.length; i++) {
                        if (result[i].Latitude != null && result[i].Longitude != null) {

                            var marker = new google.maps.Marker({
                                position: { lat: result[i].Latitude, lng: result[i].Longitude },
                                map: map,
                                nodeId: result[i].NodeId,
                                title: result[i].NodeName + '_' + result[i].NodeId,
                                icon: getMarkerIcon(result[i].MinOccupancy),
                                MinOccupancy: result[i].MinOccupancy,
                                OccupancyToday: result[i].OccupancyToday,
                                OccupancyDayOne: result[i].OccupancyDayOne,
                                OccupancyDayTwo: result[i].OccupancyDayTwo,
                                OccupancyDayThree: result[i].OccupancyDayThree
                            });


                            bounds.extend(marker.getPosition());

                            marker.addListener('click', function () {
                                counterPopupOpen++;
                                let infowindow = new google.maps.InfoWindow();
                                infoWindows.push(infowindow);
                                var markerMouserClick = this;//add this to local scope
                                infowindow.marker = markerMouserClick;
                                markerMouserClick.infowindow = infowindow;

                                google.maps.event.addListener(infowindow, 'closeclick', function () {
                                    counterPopupOpen--;
                                    infowindow.isOpen = false;
                                });

                                SetLoadingContent(infowindow);
                                infowindow.open(map, markerMouserClick);

                                var currentDate = new Date(new Date().toDateString());

                                // Post Data
                                $.ajax({
                                    type: "POST",
                                    url: appsettings.getUrl("occupancyRegion/OccupancyRegionNodesWNodeID"),
                                    data: {
                                        nodeId: parseInt(markerMouserClick.title.split('_')[1]),
                                        selectedDate: currentDate.toDateString()
                                    },
                                    success: function (data) {                                      
                                        infowindow.setContent("<div id='contentOccupancy" + markerMouserClick.title.split('_')[1] + "' style='width: 500px'></div> <div id='buttonDaysOccupancy_" + markerMouserClick.title.split('_')[1] + "'></div>");
                                        $('#contentOccupancy' + markerMouserClick.title.split('_')[1]).html(data);

                                        var currentDate = new Date(new Date().toDateString());
                                        var currentDateDayOne = addDays(currentDate, 1);
                                        var currentDateDayTwo = addDays(currentDate, 2);
                                        var currentDateDayThree = addDays(currentDate, 3);

                                        $('#buttonDaysOccupancy_' + markerMouserClick.nodeId).html(
                                            "<button id='bttn_today_" + markerMouserClick.nodeId + "' onclick='occupancyRegionMap.refreshOccupancy(this, 0, " + markerMouserClick.nodeId + " )'>" + currentDate.toLocaleDateString() + "</button> " +
                                            "<button id='bttn_dayone_" + markerMouserClick.nodeId + "' onclick='occupancyRegionMap.refreshOccupancy(this, 1, " + markerMouserClick.nodeId + " )'>" + currentDateDayOne.toLocaleDateString() + "</button> " +
                                            "<button id='bttn_daytwo_" + markerMouserClick.nodeId + "' onclick='occupancyRegionMap.refreshOccupancy(this, 2, " + markerMouserClick.nodeId + " )'>" + currentDateDayTwo.toLocaleDateString() + "</button> " +
                                            "<button id='bttn_daythree_" + markerMouserClick.nodeId + "' onclick='occupancyRegionMap.refreshOccupancy(this, 3, " + markerMouserClick.nodeId + " )'>" + currentDateDayThree.toLocaleDateString() + "</button> ");
                                        infowindow.isOpen = true;
                                        
                                        if (markerMouserClick.OccupancyToday < 100) {
                                            if (markerMouserClick.OccupancyToday == -10000) {
                                                $("#bttn_today_" + markerMouserClick.nodeId).css('background-color', 'grey');
                                            } else {
                                                $("#bttn_today_" + markerMouserClick.nodeId).css('background-color', 'red');
                                            }
                                        } else if (markerMouserClick.OccupancyToday > 100) {
                                            $("#bttn_today_" + markerMouserClick.nodeId).css('background-color', 'green');
                                        } else {
                                            $("#bttn_today_" + markerMouserClick.nodeId).css('background-color', 'orange');
                                        }

                                        if (markerMouserClick.OccupancyDayOne < 100) {
                                            if (markerMouserClick.OccupancyDayOne == -10000) {
                                                $("#bttn_dayone_" + markerMouserClick.nodeId).css('background-color', 'grey');
                                            } else {
                                                $("#bttn_dayone_" + markerMouserClick.nodeId).css('background-color', 'red');
                                            }
                                        } else if (markerMouserClick.OccupancyDayOne > 100) {
                                            $("#bttn_dayone_" + markerMouserClick.nodeId).css('background-color', 'green');
                                        } else {
                                            $("#bttn_dayone_" + markerMouserClick.nodeId).css('background-color', 'orange');
                                        }

                                        if (markerMouserClick.OccupancyDayTwo < 100) {
                                            if (markerMouserClick.OccupancyDayTwo == -10000) {
                                                $("#bttn_daytwo_" + markerMouserClick.nodeId).css('background-color', 'grey');
                                            } else {
                                                $("#bttn_daytwo_" + markerMouserClick.nodeId).css('background-color', 'red');
                                            }
                                        } else if (markerMouserClick.OccupancyDayTwo > 100) {
                                            $("#bttn_daytwo_" + markerMouserClick.nodeId).css('background-color', 'green');
                                        } else {
                                            $("#bttn_daytwo_" + markerMouserClick.nodeId).css('background-color', 'orange');
                                        }

                                        if (markerMouserClick.OccupancyDayThree < 100) {
                                            if (markerMouserClick.OccupancyDayThree == -10000) {
                                                $("#bttn_daythree_" + markerMouserClick.nodeId).css('background-color', 'grey');
                                            } else {
                                                $("#bttn_daythree_" + markerMouserClick.nodeId).css('background-color', 'red');
                                            }
                                        } else if (markerMouserClick.OccupancyDayThree > 100) {
                                            $("#bttn_daythree_" + markerMouserClick.nodeId).css('background-color', 'green');
                                        } else {
                                            $("#bttn_daythree_" + markerMouserClick.nodeId).css('background-color', 'orange');
                                        }

                                        occupancyRegion.loadNotOccupiedGroups();
                                    }
                                });
                            });

                            markers.push(marker);
                        }
                    }

                    if (!bounds.isEmpty()) {
                        map.fitBounds(bounds);
                    }

                    $('#ProgressMap').remove();
                }
            });
        }

    }
}();